import React, { useState, useContext, useCallback } from "react";
import { ReactComponent as Check } from "../assets/loginPage/check.svg";
import { ReactComponent as Group31 } from "../assets/loginPage/group-31.svg";
import maskGroup from "../assets/loginPage/mask-group.png";
import "../css/OneMoreStep.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { StyledEngineProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { Autocomplete } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import FavoriteIcon from "@mui/icons-material/Favorite";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Cta } from "../components/Cta.js";
import { UserContext } from "../context/UserContext";
import { useNavigate } from 'react-router-dom';
import ImageIcon from '@mui/icons-material/Image';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Modal, Button, IconButton, Slider } from "@mui/material";
import Cropper from 'react-easy-crop';
import CloseIcon from '@mui/icons-material/Close';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { Typography } from "@mui/material";
import { InputAdornment } from "@mui/material";

import { doc, setDoc } from "firebase/firestore"; // Import necessary functions
import { db } from '../firebase';


// Define interests options
const interestsOptions = [
    "Politics",
    "History",
    "Nostalgia",
    "Humor",
    "Hair",
    "Beauty",
    "Music",
    "Art",
    "Culture",
    "Fashion",
    "Food",
    "Travel",
    "Literature",
    "Sports",
    "Technology",
    "Health",
    "Education",
    "Entertainment"
];

const OneMoreStep = () => {
    const { user } = useContext(UserContext);
    const navigate = useNavigate();
    const storage = getStorage();

    // State for controlled form fields
    const [zip, setZip] = useState("");
    const [selectedInterests, setSelectedInterests] = useState([]);
    const [bio, setBio] = useState("");
    const [profilePicture, setProfilePicture] = useState(null);
    const [uploadProgress, setUploadProgress] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [imageSrc, setImageSrc] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [rotation, setRotation] = useState(0);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const createPopup = (messageText, type = 'success') => {
        console.log("here-1");
        const popup = document.createElement('div');
        popup.className = `popup ${type}`;
        
        const closeBtn = document.createElement('button');
        closeBtn.className = 'popup-close';
        closeBtn.innerHTML = '×';
        closeBtn.onclick = () => popup.remove();
        
        const message = document.createElement('div');
        message.className = 'popup-message';
        message.innerHTML = messageText;
        
        popup.appendChild(closeBtn);
        popup.appendChild(message);
        document.body.appendChild(popup);

        setTimeout(() => {
            popup.remove();
        }, 2000);
    };

    // Handle form submission to save data to Firestore
    const handleSubmit = async (e) => {
        console.log("here0");
        e.preventDefault();

        if (!user) {
            console.error("User not authenticated.");
            return;
        }

        try {
            let profilePictureUrl = null;
            
            // First upload the image if it exists
            if (profilePicture) {
                try {
                    // Create a unique filename using timestamp
                    const timestamp = new Date().getTime();
                    const storageRef = ref(storage, `profilePictures/${user.uid}_${timestamp}.jpg`);
                    
                    // Upload the image
                    await uploadBytes(storageRef, profilePicture);
                    
                    // Get the download URL
                    profilePictureUrl = await getDownloadURL(storageRef);
                } catch (error) {
                    createPopup("Error uploading profile picture:", 'error');
                    console.error("Error uploading profile picture:", error);
                    // You might want to show an error message to the user here
                    return;
                }
            }

            // Then save all user data including the image URL to Firestore
            const userData = {
                zipCode: parseInt(zip, 5),
                interests: selectedInterests,
                biodata: bio,
                email: user.email,
                name: user.displayName,
                nameLower: user.displayName.toLowerCase().trim(),
                searchKeyWords: user.displayName.toLowerCase().trim().split(/\s+/),
                uid: user.uid,
                friends: 0,
                following: 0,
                posts: 0,
                profilePictureUrl: profilePictureUrl,
                updatedAt: new Date().toISOString()
            };

            await setDoc(doc(db, "UserInformation", user.uid), userData);
            console.log("User data and profile picture saved successfully.");
            navigate('/');
        } catch (error) {
            createPopup("Error saving user data:", 'error');
            console.error("Error saving user data:", error);
            // You might want to show an error message to the user here
        }
    };

    const handleFileChange = async (event) => {
        console.log("here1");
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.size > 5 * 1024 * 1024) {
                setUploadProgress("File size should be less than 5MB");
                createPopup("File size should be less than 5mb:", 'error');
                return;
            }
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                setImageSrc(reader.result);
                setIsModalOpen(true);
            });
            reader.readAsDataURL(file);
        }
    };

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        console.log("here2");
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const cropperStyle = {
        position: 'relative',
        width: '100%',
        height: '50vh',
        backgroundColor: '#333',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        borderRadius: '12px',
        marginBottom: '24px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90vw',
        maxWidth: '500px',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: '12px',
        p: 0,
        overflowY: 'auto',
        maxHeight: '90vh',
    };

    const createImage = (url) =>
        new Promise((resolve, reject) => {
            const image = new Image();
            image.addEventListener('load', () => resolve(image));
            image.addEventListener('error', error => reject(error));
            image.src = url;
        });

    const getCroppedImg = async () => {
        console.log("here3");
        try {
            if (!croppedAreaPixels) {
                console.error("Cropping area not set yet.");
                createPopup("Cropping area not set yet.", 'error');
                return null;
            }
            const image = await createImage(imageSrc);
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = croppedAreaPixels.width;
            canvas.height = croppedAreaPixels.height;

            ctx.drawImage(
                image,
                croppedAreaPixels.x,
                croppedAreaPixels.y,
                croppedAreaPixels.width,
                croppedAreaPixels.height,
                0,
                0,
                croppedAreaPixels.width,
                croppedAreaPixels.height
            );

            return new Promise((resolve) => {
                canvas.toBlob((blob) => {
                    resolve(blob);
                }, 'image/jpeg');
            });
        } catch (e) {
            console.error(e);
            return null;
        }
    };

    const handleSave = async () => {
        console.log("here4");
        const croppedImage = await getCroppedImg();
        if (croppedImage) {
            setProfilePicture(croppedImage);
            setUploadProgress("Image selected");
            setIsModalOpen(false);
        } else {
            createPopup("Failed to crop image. Please try again.", 'error');
            setUploadProgress("Failed to crop image. Please try again.");
        }
    };

    return (
        <StyledEngineProvider injectFirst>
        <CssBaseline />
        <div className="auth-page">
            <div className="left-panel">
                <div className="logo-container">
                    <Group31 className="group responsive-img" />
                    <div>
                        <span className="joynet-text">JoyNet</span>
                    </div>
                </div>

                <Typography variant="subtitle2" color="primary" className="tagline">
                    YOU'RE DOING GREAT!
                </Typography>
                <Typography variant="h4" className="title-text">
                    Just One More Step
                </Typography>

                <Box
                component="form"
                className="signup-form"
                onSubmit={handleSubmit}
                >
                    <TextField
                        className="form-textfield"
                        id="zip-input"
                        label="Location (ZIP code)"
                        variant="filled"
                        value={zip}
                        onChange={(e) => setZip(e.target.value)}
                        multiline
                        minRows={1}
                        maxRows={3}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start" sx={{ height: '100%', marginTop: '0 !important' }}>
                                    <LocationOnIcon sx={{ color: "gray", mr: 1, fontSize: '20px' }} />
                                </InputAdornment>
                            ),
                            disableUnderline: true
                        }}
                        sx={{
                            '& .MuiInputBase-root': {
                                overflow: 'hidden',
                                minHeight: '35px !important',
                                height: 'auto',
                                alignItems: 'center',
                                paddingTop: '0 !important'
                            },
                            '& .MuiFilledInput-root': {
                                '&:before, &:after': {
                                    display: 'none',
                                },
                                paddingLeft: '12px'
                            },
                            '& .MuiFilledInput-input': {
                                padding: '4px 0'
                            },
                            '& .MuiInputLabel-root': {
                                transform: 'translate(14px, 6px) scale(0.9)'
                            },
                            '& .MuiInputLabel-root.Mui-focused': {
                                transform: 'translate(14px, -12px) scale(0.75)'
                            },
                            '& .MuiInputAdornment-root': {
                                marginTop: '0 !important',
                                height: '100%',
                                maxHeight: '35px',
                                alignItems: 'center',
                                marginRight: '4px'
                            }
                        }}
                    />
                <Autocomplete
                    multiple
                    id="interests"
                    disableCloseOnSelect
                    options={interestsOptions}
                    value={selectedInterests}
                    onChange={(event, newValue) => {
                        setSelectedInterests(newValue);
                    }}
                    renderOption={(props, option, { selected }) => (
                        <li {...props}>
                            {selected ? (
                                <CheckBoxIcon fontSize="small" sx={{ mr: 1 }} />
                            ) : (
                                <CheckBoxOutlineBlankIcon fontSize="small" sx={{ mr: 1 }} />
                            )}
                            {option}
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="filled"
                            label={selectedInterests.length === 0 ? "Interests" : ""}
                            className="form-textfield"
                            multiline
                            minRows={1}
                            maxRows={4}
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                    <InputAdornment position="start" sx={{ height: '100%', marginTop: '0 !important' }}>
                                        <FavoriteIcon sx={{ color: "gray", mr: 1, fontSize: '20px' }} />
                                        {params.InputProps.startAdornment}
                                    </InputAdornment>
                                ),
                                disableUnderline: true
                            }}
                            sx={{
                                '& .MuiInputBase-root': {
                                    overflow: 'hidden',
                                    minHeight: '35px !important',
                                    height: 'auto',
                                    alignItems: 'center',
                                    paddingTop: '0 !important'
                                },
                                '& .MuiFilledInput-root': {
                                    '&:before, &:after': {
                                        display: 'none',
                                    },
                                    paddingLeft: '12px'
                                },
                                '& .MuiFilledInput-input': {
                                    padding: '4px 0'
                                },
                                '& .MuiInputLabel-root': {
                                    transform: 'translate(14px, 6px) scale(0.9)'
                                },
                                '& .MuiInputLabel-root.Mui-focused': {
                                    transform: 'translate(14px, -12px) scale(0.75)'
                                },
                                '& .MuiInputAdornment-root': {
                                    marginTop: '0 !important',
                                    height: '100%',
                                    maxHeight: '35px',
                                    alignItems: 'center',
                                    marginRight: '4px'
                                }
                            }}
                        />
                    )}
                />
                <TextField
                    className="form-textfield bio-field"
                    id="bio-input"
                    label="Bio"
                    variant="filled"
                    value={bio}
                    onChange={(e) => setBio(e.target.value)}
                    multiline
                    minRows={1}
                    maxRows={6}
                    InputProps={{
                        disableUnderline: true,
                        startAdornment: <PersonIcon sx={{ color: "gray", mr: 1, mt: '2px' }} />
                    }}
                    sx={{
                        '& .MuiInputBase-root': {
                            overflow: 'hidden',
                            minHeight: '35px !important',
                            height: 'auto',
                            alignItems: 'flex-start',
                            paddingTop: '0 !important'
                        },
                        '& .MuiFilledInput-root': {
                            '&:before, &:after': {
                                display: 'none',
                            },
                        },
                        '& .MuiFilledInput-input': {
                            padding: '4px 0'
                        },
                        '& .MuiInputLabel-root': {
                            transform: 'translate(14px, 6px) scale(0.9)'
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            transform: 'translate(14px, -12px) scale(0.75)'
                        },
                        '& .MuiInputAdornment-root': {
                            marginTop: '0 !important',
                            height: '100%',
                            maxHeight: '35px',
                            alignItems: 'center'
                        }
                    }}
                />
                <div style={{ marginTop: '16px', marginBottom: '24px' }}>
                    <input
                        accept="image/*"
                        style={{ display: 'none' }}
                        id="profile-picture-input"
                        type="file"
                        onChange={handleFileChange}
                    />
                    <label htmlFor="profile-picture-input" style={{ width: '100%' }}>
                        <Button
                            variant="contained"
                            component="span"
                            startIcon={<ImageIcon />}
                            fullWidth
                            sx={{
                                bgcolor: '#007AFF',
                                color: 'white',
                                textTransform: 'none',
                                padding: '15px',
                                borderRadius: '12px',
                                '&:hover': {
                                    bgcolor: '#0056b3'
                                }
                            }}
                        >
                            {uploadProgress || "Upload Profile Picture"}
                        </Button>
                    </label>
                </div>
                <Modal
                    open={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    aria-labelledby="modal-modal-title"
                >
                    <Box sx={modalStyle}>
                        <Box sx={{ p: 3 }}>
                            <Box sx={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center', 
                                mb: 3,
                                borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                                pb: 2
                            }}>
                                <Typography variant="h6">Crop Profile Picture</Typography>
                                <IconButton onClick={() => setIsModalOpen(false)} size="small">
                                    <CloseIcon />
                                </IconButton>
                            </Box>

                            <Box sx={cropperStyle}>
                                {imageSrc && (
                                    <Cropper
                                        image={imageSrc}
                                        crop={crop}
                                        zoom={zoom}
                                        rotation={rotation}
                                        aspect={1}
                                        onCropChange={setCrop}
                                        onCropComplete={onCropComplete}
                                        onZoomChange={setZoom}
                                        onRotationChange={setRotation}
                                        objectFit="contain"
                                        cropShape="round"
                                        showGrid={false}
                                    />
                                )}
                            </Box>

                            <Box sx={{ mt: 3 }}>
                                <Box sx={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    gap: 2, 
                                    mb: 3,
                                    p: 2,
                                    backgroundColor: 'rgba(0, 0, 0, 0.03)',
                                    borderRadius: '8px'
                                }}>
                                    <ZoomOutIcon sx={{ color: 'text.secondary' }} />
                                    <Slider
                                        value={zoom}
                                        min={1}
                                        max={3}
                                        step={0.1}
                                        aria-labelledby="zoom-slider"
                                        onChange={(e, zoom) => setZoom(zoom)}
                                        sx={{
                                            '& .MuiSlider-thumb': {
                                                backgroundColor: '#007AFF',
                                            },
                                            '& .MuiSlider-track': {
                                                backgroundColor: '#007AFF',
                                            },
                                            '& .MuiSlider-rail': {
                                                backgroundColor: '#E0E0E0',
                                            }
                                        }}
                                    />
                                    <ZoomInIcon sx={{ color: 'text.secondary' }} />
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button
                                        variant="contained"
                                        onClick={handleSave}
                                        disabled={!croppedAreaPixels}
                                        sx={{
                                            bgcolor: '#007AFF',
                                            color: 'white',
                                            '&:hover': {
                                                bgcolor: '#0056b3'
                                            },
                                            textTransform: 'none',
                                            px: 4,
                                            py: 1.5,
                                            borderRadius: '8px'
                                        }}
                                    >
                                        Save
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Modal>
                <Cta
                    type="submit"
                    text="Next"
                    className="login-cta"
                    style={{
                        cursor: "pointer",
                        marginTop: '8px',
                        marginBottom: '24px',
                    }}
                />
                </Box>
            </div>

            <div className="right-panel">
                <div className="benefit-card">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Check className="benefit-icon" />
                        <div>
                            <div className="benefit-title">Begin Your Journey to Healing</div>
                            <div className="benefit-description">
                                Find solace and connection in our community. The JoyNet App is a sanctuary where conversations heal and uplift.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="benefit-card">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Check className="benefit-icon" />
                        <div>
                            <div className="benefit-title">Simplicity in Connection, Richness in Experience</div>
                            <div className="benefit-description">
                                Signing up is just the start. Join chatrooms, connect with kindred spirits, and share in the celebration of Black Joy.
                            </div>
                        </div>
                    </div>
                </div>
                <img src={maskGroup} alt="Illustration" className="auth-image" />
            </div>
        </div>
        </StyledEngineProvider>

    );
};


export default OneMoreStep;
